import React, { Component } from 'react'

import {
  map,
} from 'lodash'

import { ResponsiveContainer, Cell } from "../ResponsiveGrid"
import Link from '../Link'
import Logo from '../Logo'

import './styles.scss'

class MainMenu extends Component {

  static defaultProps = {
    title: 'Atrakeur',
    items: [
      {
        name: 'Blog',
        target:'/blog',
      },
      {
        name: 'Projets',
        target:'/projects',
      }
    ],
  }

  render () {
    const {
      title,
      items,
    } = this.props

    return (
      <nav className="Atrakeur-MainMenu">
        <Link to="/">
          <Logo className="Atrakeur-Logo" />
        </Link>
        <ul className="Atrakeur-MainMenu-Items">
          { map(items, item => (
            <li className="Atrakeur-MainMenu-Item" key={item.target}>
              { item.target ? <Link to={item.target}>{ item.name }</Link> : item.name }
            </li>
          ))}
        </ul>
      </nav>
    )
  }
}
export default MainMenu


// WEBPACK FOOTER //
// ./src/components/MainMenu/index.js